import {
    ChevronRight,
    ChevronLeft,
    RightLightBackgroundIcon,
    RightDarkBackgroundIcon,
    LeftDarkBackgroundIcon,
    LeftLightBackgroundIcon,
} from '../../icons'
import {BRAND_KEY} from '../../../brand'

const ARROWS = {
    default: {
        white: {right: ChevronRight, left: ChevronLeft},
        black: {right: ChevronRight, left: ChevronLeft},
    },
    braun: {
        white: {right: RightDarkBackgroundIcon, left: LeftDarkBackgroundIcon},
        black: {right: RightLightBackgroundIcon, left: LeftLightBackgroundIcon},
    },
}

const ICONS = {
    Arrows: ARROWS[BRAND_KEY] ?? ARROWS.default,
}

export default ICONS
